// If value is null or undefined then return a specified default value, if not then return the value
export const getValueForDefault = <T extends string | number | number[]>(value: Nullable<T>, defaultValue: T): T => {
    if (Array.isArray(value)) {
        return value && value.length === 1 ? value : defaultValue
    }
    return value || defaultValue
}

export const getValueIfNullOrUndefined = <T extends string | number | number[] | undefined>(
    value: Nullable<T>,
    defaultValue: T
): T => {
    if (value === undefined || value === null) {
        return defaultValue
    }
    return value
}
